import { cn } from '@lib/util/cn';

const colorClasses = {
  orange: 'bg-orange-100 text-orange-800 border-orange-200',
  green: 'bg-green-100 text-green-800 border-green-200',
  'green-outline':
    'bg-brand-success-50 text-green-800 border-brand-success-600',
  red: 'bg-red-100 text-red-800 border-red-200',
  'red-outline': 'bg-brand-danger-50 text-red-800 border-brand-danger-600',
  'yellow-outline':
    'bg-brand-warning-50 border-brand-warning-600 text-brand-warning-900',
  blue: 'bg-blue-100 text-blue-800 border-blue-200',
  grey: 'bg-gray-100 text-gray-800 border-gray-200',
  purple: 'bg-purple-100 text-purple-800 border-purple-200',
} as const;

type BadgeColor = keyof typeof colorClasses;

type BadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
  color?: BadgeColor;
};

function Badge({ color = 'grey', className, children, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium',
        colorClasses[color],
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}

export { Badge };
